import { downloadExcelWorkbook } from '../reports/exportExcelWorkbook';
import type { RevenueReportResult } from './types';

export const exportRevenueReport = async (report: RevenueReportResult): Promise<void> => {
  const { default: ExcelJS } = await import('exceljs');
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Revenue Report');

  worksheet.columns = [
    { header: 'Employee', key: 'employeeName', width: 30 },
    { header: 'Invoice Currency', key: 'currencyName', width: 18 },
    { header: 'Summary', key: 'summary', width: 16 },
    { header: 'Cost', key: 'cost', width: 16 },
    { header: 'Revenue', key: 'revenue', width: 16 },
    { header: 'Revenue EUR', key: 'revenueEur', width: 18 },
  ];
  worksheet.getRow(1).font = { bold: true };
  report.rows.forEach((row) => worksheet.addRow(row));

  worksheet.addRow([]);
  const totalsHeader = worksheet.addRow(['Employee', 'Total Revenue EUR']);
  totalsHeader.font = { bold: true };
  report.employeeTotals.forEach((total) => {
    worksheet.addRow([total.employeeName, total.totalRevenueEur]);
  });
  const grandTotal = worksheet.addRow(['Grand Total Revenue EUR', report.grandTotalRevenueEur]);
  grandTotal.font = { bold: true };

  if (report.warnings.length > 0) {
    worksheet.addRow([]);
    report.warnings.forEach((warning) => worksheet.addRow([warning]));
  }

  if (report.excludedLines.length > 0) {
    worksheet.addRow([]);
    const excludedLinesHeader = worksheet.addRow([
      'Excluded Invoice',
      'Line ID',
      'Description',
      'Employee',
      'Reason',
    ]);
    excludedLinesHeader.font = { bold: true };
    report.excludedLines.forEach((line) => {
      worksheet.addRow([
        line.invoiceNumber || `#${line.invoiceId}`,
        line.invoiceLineId,
        line.description,
        line.employeeName,
        line.reason,
      ]);
    });
  }

  const buffer = await workbook.xlsx.writeBuffer();
  downloadExcelWorkbook(buffer, `Revenue_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
};
